var CommonController = function() {
    this.MenuToggle = require('../module/MenuToggle');
    this.SearchToggle = require('../module/SearchToggle');
    this.InfiniteScroll = require('../module/InfiniteScroll');
    var customSelector = require('../module/customSelector');
    customSelector();
    this.init();
};

CommonController.prototype = {
    init: function() {
        var menuToggle = new this.MenuToggle();
        menuToggle.init();

        var searchToggle = new this.SearchToggle();
        searchToggle.init();

        if (window.matchMedia('screen and (max-width: 736px)').matches) {
            $('body').addClass('smp');

        } else if (window.matchMedia('screen and (max-width: 1240px)').matches) {
            $('body').addClass('tb');
        }
    }
};

module.exports = CommonController;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/controller/CommonController.js
 **/